//User Actions
export const UserActionTypes = {
  AUTH_USER: "AUTH_USER",
  DESTORY_SESSION: "DESTORY_SESSION",
};
